<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.servicoEnfermagem"
                    :requestQueryStringParams="{
                        paciente_id: data.form.paciente.id,
                        search_by_apelido: additionals.searchByApelido,
                    }"
                    :searchFields="fields"
                    :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                    :validations="validations.procedimento"
                    label="Procedimento"
                    v-model="model.procedimento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.observacoes"
                    label="Observações"
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { formats, repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return this.additionals.searchByApelido
                ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }]
        },
        validations() {
            return {
                procedimento: { required: true },
                observacoes: { max: 100 },
            }
        },
    },
    created() {
        this.repositories.parametrizacao = this.getConectaSusRepository('prontoAtendimento.parametrizacao')

        if (this.model.procedimento) {

            this.previousProcedimentoId = this.model.procedimento.id
        }
    },
    data: () => ({
        additionals: {
            searchByApelido: false,
        },
        repositories: [],
        previousProcedimentoId: null
    }),
    methods: {
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {

                    const duplicado = this.data.model.servicosEnfermagem
                        .find(item => {

                            if (!Number.isInteger(item.id)) {

                                return item.procedimento.id === this.model.procedimento.id
                            }

                            return false
                        })

                    if (duplicado) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: `Este serviço de enfermagem já foi cadastrado.`
                        })
                    } else {

                        if (this.previousProcedimentoId !== this.model.procedimento.id) {

                            this.model.cid = null
                        }

                        if (this.model.id) {
                            const index = this.data.model.servicosEnfermagem.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.servicosEnfermagem[index], this.model)
                        } else {
                            this.model.id = this.uniqueId('pronto-atendimento-servico-enfermagem')
                            this.data.model.servicosEnfermagem.push(this.model)
                        }

                        this.$emit('saved', this.model)
                    }
                }
            })
        },
    },
    mixins: [formats, repository],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>